import React from 'react';
import { BookOpen, LucideIcon } from 'lucide-react';

// FooterAction组件的Props接口
interface FooterActionProps {
  onClick: () => void;
  text: string;
  icon?: LucideIcon;
  variant?: 'default' | 'primary' | 'secondary';
  disabled?: boolean;
  className?: string;
}

/**
 * FooterAction组件 - 底部操作区域
 * 提供查看深度指导等操作的入口点
 */
const FooterAction: React.FC<FooterActionProps> = ({ 
  onClick, 
  text, 
  icon: Icon = BookOpen,
  variant = 'default',
  disabled = false,
  className = ''
}) => {
  // 根据variant确定按钮样式
  const getVariantStyles = () => {
    switch (variant) {
      case 'primary':
        return 'bg-blue-600 text-white hover:bg-blue-700 border-blue-600';
      case 'secondary':
        return 'bg-gray-100 text-gray-700 hover:bg-gray-200 border-gray-300';
      default:
        return 'bg-transparent text-gray-600 hover:bg-gray-50 hover:text-gray-800 border-gray-300';
    }
  };

  // 禁用状态样式
  const disabledStyles = disabled 
    ? 'opacity-50 cursor-not-allowed hover:bg-transparent hover:text-gray-600' 
    : 'cursor-pointer';

  return (
    <button
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      className={`
        inline-flex items-center justify-center space-x-2 
        px-4 py-2 border rounded-lg font-medium text-sm
        transition-all duration-200 ease-in-out
        focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2
        ${getVariantStyles()}
        ${disabledStyles}
        ${className}
      `}
    >
      <Icon className="w-4 h-4" />
      <span>{text}</span>
    </button>
  );
};

export default FooterAction;